import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * One query client for the app. Nothing is persisted to disk: a shared family phone
 * must never be able to replay a giver's view of a list (doc 03, leak checklist 8–9).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Never retry something the server already answered clearly.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

/** Called on sign-out: everything cached about the previous person goes. */
export function clearQueryCache() {
  queryClient.clear();
}

export const queryKeys = {
  me: ['me'] as const,
  config: ['config'] as const,
  family: (familyId: string) => ['family', familyId] as const,
  joinPreview: (code: string) => ['join-preview', code] as const,
};
